import React from "react"
import { Link } from "react-router-dom"
import { DropTarget } from "react-dnd"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { moveProjectsToFolder } from "@api/project_folders"
import PropTypes from "prop-types"
import flow from "lodash.flow"

// Root drop target
const rootTarget = {
  drop(props, monitor) {
    const item = monitor.getItem()
    props.moveProjectsToFolder([item.project._id], {
      _id: "all_projects",
      title: "All Projects"
    })
  }
}

const rootCollect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver()
})

// Breadcrumb drop target (re-used)
const folderTarget = {
  canDrop(props) {
    // prevent drop on the current (last) folder
    return !props.isLast
  },
  drop(props, monitor) {
    const item = monitor.getItem()
    props.moveProjectsToFolder([item.project._id], {
      _id: props.folderID,
      title: props.title
    })
  }
}

const folderCollect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop()
})

const RootBreadcrumb = ({ connectDropTarget, isOver, draggingProject }) => {
  const isActive = isOver && draggingProject
  const style = {
    textDecoration: isActive ? "underline" : "none",
    backgroundColor: isActive ? "#fb0f3b22" : "transparent",
    color: isActive ? "black" : "gray",
    borderRadius: "8px",
    padding: "2px 4px"
  }

  return connectDropTarget(
    <div className="pr1">
      <Link to="/projects" style={style}>
        Projects
      </Link>
    </div>
  )
}

const BreadcrumbItem = ({
  crumb,
  isLast,
  connectDropTarget,
  isOver,
  canDrop,
  draggingProject
}) => {
  const isActive = isOver && canDrop && draggingProject
  const style = {
    textDecoration: isActive ? "underline" : "none",
    backgroundColor: isActive ? "#fb0f3b22" : "transparent",
    color: isActive || isLast ? "black" : "gray",
    borderRadius: "8px",
    padding: "2px 4px"
  }

  return connectDropTarget(
    <div className="flex items-center pr1">
      <div className="material-icons mr1 muted">keyboard_arrow_right</div>
      {isLast ? (
        <span style={style}>{crumb.title}</span>
      ) : (
        <Link
          to={`/projects/folder/${crumb.slug}`}
          style={style}
        >
          {crumb.title}
        </Link>
      )}
    </div>
  )
}

const Breadcrumb = ({ breadcrumb = [], draggingProject }) => (
  <h4 className="flex items-center flex-auto">
    <ConnectedRootBreadcrumb draggingProject={draggingProject} />
    {breadcrumb.map((crumb, i) => (
      <ConnectedBreadcrumbItem
        key={i}
        crumb={crumb}
        isLast={i === breadcrumb.length - 1}
        folderID={crumb._id}
        title={crumb.title}
        draggingProject={draggingProject}
      />
    ))}
  </h4>
)

Breadcrumb.propTypes = {
  breadcrumb: PropTypes.array,
  draggingProject: PropTypes.object
}

const mapStateToProps = (state) => ({
  draggingProject: state.projects.draggingProject
})

const mapDispatchToProps = (dispatch) => ({
  moveProjectsToFolder: bindActionCreators(moveProjectsToFolder, dispatch)
})

const ConnectedRootBreadcrumb = flow(
  DropTarget("PROJECT", rootTarget, rootCollect),
  connect(mapStateToProps, mapDispatchToProps)
)(RootBreadcrumb)

const ConnectedBreadcrumbItem = flow(
  DropTarget("PROJECT", folderTarget, folderCollect),
  connect(mapStateToProps, mapDispatchToProps)
)(BreadcrumbItem)

export default Breadcrumb
